import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createLocation: [],
    loading: false,
    error: null,
};

const createLocationSlice = createSlice({
    name: "createLocation",
    initialState,
    reducers: {
        fetchCreateLocationRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchCreateLocationSuccess: (state, action) => {
            state.loading = false;
            state.createLocation = action.payload;
        },
        fetchCreateLocationFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchCreateLocationRequest,
    fetchCreateLocationSuccess,
    fetchCreateLocationFailure,
} = createLocationSlice.actions;

export default createLocationSlice.reducer;